module.exports = __webpack_public_path__ + "media/images/icons/icon_hand-f721929290d9aca365f02cb4e4ebdb2d.svg";